<script setup lang="ts">
import type { JSX } from '@ionic/core'

const modelValue = defineModel<string | number>()
const props = withDefaults(defineProps<JSX.IonInput & {
	isRequired?: boolean
}>(),
{
	type: 'text',
	errorText: undefined,
})

// Ionic Input schreiben Leer Strings in das ModelValue, wenn man den Input leert.
// Für die Validierung und das Senden der Daten an das Backend ist es jedoch besser, wenn der Wert undefined ist.
const normalizedValue = computed({
	get: () => modelValue.value === '' ? undefined : modelValue.value,
	set: (v) => {
		modelValue.value = v === '' ? undefined : v
	},
})

const computedLabel = computed(() => {
	return props.label ? props.label + (props.isRequired ? '*' : '') : undefined
})
</script>

<template>
	<ion-input
		v-model="normalizedValue"
		v-bind.attr="$attrs"
		v-bind.prop="props"
		:class="{ 'ion-invalid': !!props.errorText, 'ion-touched': !!props.errorText }"
		:error-text="errorText"
		:label="computedLabel"
	/>
</template>
